// ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/home" />;
  }
  const studentRole = ["student", "promo_t1", "promo_t2"]
  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role.role_name)) {
    // Redirect students to their dashboard, others to 404
    if (studentRole.includes(user.role.role_name)) {
      return <Navigate to="/student" />;
    }else{
      return <Navigate to="/dashboard" />;
    }
  }

  return children;
};

export default ProtectedRoute;